// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCsP1QuKKoa8DAQUT9BpfmQTioJtnXKcEI",
  authDomain: "restauranteoda-28d1a.firebaseapp.com",
  projectId: "restauranteoda-28d1a",
  storageBucket: "restauranteoda-28d1a.appspot.com",
  messagingSenderId: "411938517926",
  appId: "1:411938517926:web:0c6db901a5154dc95c5567",
  measurementId: "G-ST0PCPRWHJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export default app;